import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';

const ReserveDetail = (props) => {
  const { match, loginId, apiUrl, pkg, history, imgUrl } = props;
  const [payData, setPayData] = useState([]);
  const [code, setCode] = useState('');
  const [confirm, setConfirm] = useState('N');
  const [modalShow, setModalShow] = useState(false);
  const [cancelShow, setCancelShow] = useState(false);

  let orderCode = match.params.orderCode;
  // console.log(orderCode, loginId, pkg, "a");

  const _getData = async () => {
    const result = await axios.post(apiUrl + '/exhibitionDetail', {
      orderCode: orderCode,
      userid: loginId,
      pkg,
    });

    const intReturn = result.data[0].intReturn;
    const listData = result.data[0].listData;

    if (intReturn === 0) {
      setPayData(listData);
      setConfirm(listData[0].chkTicket);
    } else {
      alert(intReturn);
    }
  };
  const _change = (e) => {
    setCode(e.target.value);
  };
  const _confirm = async () => {
    if (code === undefined || code === null || code === '') {
      toast.warn('발권 승인코드를 입력해주세요.');
    } else {
      const result = await axios.post(apiUrl + '/exhibitionConfirm', {
        code: code,
        exhibitionCode: payData[0].exhibitionCode,
        orderCode: orderCode,
        userid: loginId,
        pkg: pkg,
      });

      const intReturn = result.data[0].intReturn;
      if (intReturn === 0) {
        setConfirm('Y');
        setModalShow(true);
      } else if (intReturn === -2) {
        toast.error('취도되었거나 발권된 예매권입니다.');
      } else if (intReturn === -3) {
        toast.error('발권 승인코드가 일치하지 않습니다.');
      } else {
        toast.error('오류가 발생했습니다.');
      }
    }
  };
  const _list = () => {
    history.push('/reserveList');
  };

  const _preDel = () => {
    setCancelShow(true);
    // confirmAlert({
    //   title: '취소',
    //   message: '예매내역을 취소하시겠습니까? ',
    //   buttons: [
    //     {
    //       label: '예매취소',
    //       onClick: () => _cancel(),
    //     },

    //     {
    //       label: '닫기',
    //     },
    //   ],
    // });
  };
  const _cancel = async () => {
    const orderCode = payData[0].orderCode;
    const paymentKey = payData[0].paymentKey;
    const result = await axios.post(apiUrl + '/exhibitionCancel', {
      orderCode: orderCode,
      paymentKey: paymentKey,
      userid: loginId,
      pkg: pkg,
    });

    const intReturn = result.data[0].intReturn;
    if (intReturn === 0) {
      toast.success('성공적으로 결제 취소가 완료되었습니다.');
      _getData();
      setCancelShow(false);
    } else if (intReturn === -100) {
      toast.error('취소중 오류가 발생했습니다.');
    } else if (intReturn === -3) {
      toast.error('관람일 2일전까지만 취소가 가능합니다.');
    } else if (intReturn === -2) {
      toast.error('오류로 인해 취소가 롤백되었습니다.');
    }
  };
  const CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  const _closeModal = () => {
    setModalShow(false);
  };

  useEffect(() => {
    if (loginId === null || loginId === undefined || loginId === '') {
      history.push('/login');
    } else {
      _getData();
    }
  }, []);

  if (payData.length <= 0) {
    return <div></div>;
  }

  return (
    <>
      <div id="wrap">
        <a className="prev" onClick={_list} style={{ cursor: 'pointer' }}></a>
        {/* <!-- 컨텐츠영역 --> */}
        <section className="container5 tiket2">
          {/* <!-- 왼쪽 컨텐츠 --> */}
          <div className="bx bx_left">
            <h1>
              <img src={imgUrl + '/img/mediaArt/logo.svg'} alt="" />
            </h1>
            <div className="comfirm">
              <div className="icon">
                {payData[0].cancel === false && confirm === 'N' && (
                  <img src={imgUrl + '/img/mediaArt/icon_comfirm.gif'} alt="" />
                )}
                {confirm === 'Y' && (
                  <img
                    src={imgUrl + '/img/mediaArt/icon_comfirm2.gif'}
                    alt=""
                  />
                )}
                {payData[0].cancel === true && (
                  <img
                    src={imgUrl + '/img/mediaArt/icon_comfirm2.gif'}
                    alt=""
                  />
                )}
              </div>
              <div className="txt">
                {payData[0].exhibitionName}
                <br />
                {payData[0].cancel === true && '예매권 취소가 완료되었습니다.'}
                {confirm === 'Y' && '예매권 발권이 완료되었습니다.'}
                {payData[0].cancel === false &&
                  confirm === 'N' &&
                  '예매권 결제가 완료되었습니다.'}
              </div>
            </div>
            <div className="section sec_item">
              <h2>예매 내역</h2>
              <div className="item">
                <div className="thumb">
                  <img src={payData[0].img} alt="" />
                </div>
                <ul>
                  <li>
                    <span className="tit">작품명</span>
                    <span className="txt">{payData[0].exhibitionName}</span>
                  </li>
                  <li>
                    <span className="tit">장소</span>
                    <span className="txt">
                      {payData[0].exhibitionLocationName}
                    </span>
                  </li>
                  <li>
                    <span className="tit">날짜</span>
                    <span className="txt">
                      {moment(
                        payData[0].rdate.toString().substring(0, 4) +
                          '-' +
                          payData[0].rdate.toString().substring(4, 6) +
                          '-' +
                          payData[0].rdate.toString().substring(6, 8)
                      ).format('YYYY.MM.DD(dd)')}
                    </span>
                  </li>
                  <li>
                    <span className="tit">시간</span>
                    <span className="txt">{payData[0].rtimeName}</span>
                  </li>
                  <li>
                    <span className="tit">예매수</span>
                    <span className="txt">{payData[0].rcount}매</span>
                  </li>
                  <li>
                    <span className="tit">결제금액</span>
                    <span className="txt">
                      {CommaFormatted(payData[0].price)}원
                      {payData[0].early === 'Y' ? ' (얼리버드)' : ''}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="section sec_paycont">
              <h2>결제 내역</h2>
              <ul>
                <li>
                  <span className="tit">결제수단</span>
                  <span className="txt">
                    {payData[0].payType} |{' '}
                    {payData[0].payType === '간편결제'
                      ? payData[0].payName
                      : payData[0].codeName}
                  </span>
                </li>
                <li>
                  <span className="tit">결제일1</span>
                  <span className="txt">
                    {moment(new Date(payData[0].regDate)).format(
                      'YYYY.MM.DD HH:mm'
                    )}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          {/* <!-- 오른쪽 컨텐츠 --> */}
          <div className="bx bx_right">
            <div className="section_line">
              <div className="comfirm">
                <div className="icon">
                  {payData[0].cancel === false && confirm === 'N' && (
                    <img
                      src={imgUrl + '/img/mediaArt/icon_comfirm.gif'}
                      alt=""
                    />
                  )}
                  {confirm === 'Y' && (
                    <img
                      src={imgUrl + '/img/mediaArt/icon_comfirm2.gif'}
                      alt=""
                    />
                  )}
                  {payData[0].cancel === true && (
                    <img
                      src={imgUrl + '/img/mediaArt/icon_comfirm2.gif'}
                      alt=""
                    />
                  )}
                </div>

                <div className="txt">
                  {payData[0].exhibitionName}
                  <br />
                  {payData[0].cancel === true &&
                    '예매권 취소가 완료되었습니다.'}
                  {confirm === 'Y' && '예매권 발권이 완료되었습니다.'}
                  {payData[0].cancel === false &&
                    confirm === 'N' &&
                    '예매권 결제가 완료되었습니다.'}
                </div>
              </div>
            </div>
            <div className="section section_line">
              {payData[0].cancel === false ? (
                confirm === 'N' ? (
                  <div className="sec_approve">
                    <h2>
                      승인번호(예매당일 전시장 입장시 스태프가 입력하는
                      곳입니다. )
                    </h2>
                    <div className="approve_input">
                      <input
                        type="text"
                        className="input"
                        name="confirmCode"
                        value={code}
                        onChange={_change}
                        maxLength={6}
                      />
                      <a onClick={_confirm} style={{ cursor: 'pointer' }}>
                        발권승인
                      </a>
                    </div>
                  </div>
                ) : (
                  <div className="txt"></div>
                )
              ) : (
                <div className="txt"></div>
              )}
            </div>
            <div className="section section_line sec_item">
              <h2>예매 내역</h2>
              <div className="item">
                <div className="thumb">
                  <img src={payData[0].img} alt="" />
                </div>
                <ul>
                  <li>
                    <span className="tit">작품명</span>
                    <span className="txt">{payData[0].exhibitionName}</span>
                  </li>
                  <li>
                    <span className="tit">장소</span>
                    <span className="txt">
                      {payData[0].exhibitionLocationName}
                    </span>
                  </li>
                  <li>
                    <span className="tit">날짜</span>
                    <span className="txt">
                      {' '}
                      {moment(
                        payData[0].rdate.toString().substring(0, 4) +
                          '-' +
                          payData[0].rdate.toString().substring(4, 6) +
                          '-' +
                          payData[0].rdate.toString().substring(6, 8)
                      ).format('YYYY.MM.DD(dd)')}
                    </span>
                  </li>
                  <li>
                    <span className="tit">시간</span>
                    <span className="txt">{payData[0].rtimeName}</span>
                  </li>
                  <li>
                    <span className="tit">예매수</span>
                    <span className="txt">{payData[0].rcount}매</span>
                  </li>
                  <li>
                    <span className="tit">결제금액</span>
                    <span className="txt">
                      {CommaFormatted(payData[0].price)}원
                      {payData[0].early === 'Y' ? ' (얼리버드)' : ''}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="section section_line sec_paycont">
              <h2>결제 내역</h2>
              <ul>
                <li>
                  <span className="tit">결제수단</span>
                  <span className="txt">
                    {' '}
                    {payData[0].payType} |{' '}
                    {payData[0].payType === '간편결제'
                      ? payData[0].payName
                      : payData[0].codeName}
                  </span>
                </li>
                <li>
                  <span className="tit">결제일</span>
                  <span className="txt">
                    {moment(new Date(payData[0].regDate)).format(
                      'YYYY.MM.DD HH:mm'
                    )}
                  </span>
                </li>
              </ul>
            </div>
            <div className="section">
              <div className="btn_area">
                {payData[0].cancel === false &&
                  payData[0].cancelFlag === 'live' &&
                  confirm === 'N' && (
                    <a onClick={_preDel} style={{ cursor: 'pointer' }}>
                      예매취소
                    </a>
                  )}
                {payData[0].cancel === false &&
                  payData[0].cancelFlag === 'expired' &&
                  confirm === 'N' && <a>취소기간 만료</a>}

                {payData[0].cancel === true && <a>취소완료</a>}
                {confirm === 'Y' && <a>발권완료</a>}

                <a onClick={_list} style={{ cursor: 'pointer' }}>
                  나의 예매내역
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
      {modalShow && (
        <>
          <div className="dimmed"></div>
          <div className="modal modal_comfirm">
            <div className="icon">
              <img src={imgUrl + '/img/mediaArt/icon_comfirm2.gif'} alt="" />
            </div>
            <p className="txt">발권승인 완료되었습니다.</p>
            <div className="btn_area">
              <a onClick={_closeModal} style={{ cursor: 'pointer' }}>
                확인
              </a>
            </div>
          </div>
        </>
      )}
      {cancelShow && (
        <>
          <div className="dimmed"></div>
          <div className="modal modal_comfirm">
            <div className="icon">
              <img src={imgUrl + '/img/mediaArt/warning.gif'} alt="" />
            </div>
            <p className="txt">예매내역을 취소하시겠습니까?</p>
            <div className="btn_area">
              <a onClick={_cancel} style={{ cursor: 'pointer' }}>
                확인
              </a>
              <a
                onClick={() => setCancelShow(false)}
                style={{ cursor: 'pointer' }}
              >
                닫기
              </a>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default shopContext(withRouter(ReserveDetail));
